import React, { FC } from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { Tooltip } from '@mui/material';
import { LinkOff } from '@mui/icons-material';
import { CitationLinkExtensionRenderOptions } from '../plugins/CitationLink';
import { useGuideCmsContext } from '../../../GuideCmsContext';
import { useCitationIndex } from '../../citationNumbering';
import { RichText } from '../../../../../components/richText';

const renderText = (node: ProseMirrorNode) => {
  return `[${node.attrs.citationId}]`;
};

export const CitationLinkView: FC<NodeViewProps> = (props) => {
  const { getCitationText } = useGuideCmsContext();
  const citationId = props.node.attrs.citationId as string;
  const text = getCitationText(citationId);
  const index = useCitationIndex(citationId, props.editor);
  const isBroken = text === null;
  if (isBroken) {
    return (
      <NodeViewWrapper className="react-component" as="span">
        <Tooltip title="Litteraturhenvisningen er slettet. Fjern lenken eller legg til en ny henvisning.">
          <span className="link link-citation link-citation--broken">
            <LinkOff fontSize="inherit" sx={{ verticalAlign: 'text-bottom', mr: '2px' }} />
            Slettet litteraturhenvisning
          </span>
        </Tooltip>
      </NodeViewWrapper>
    );
  }
  const label = index != null ? `[${index}]` : '[?]';
  return (
    <NodeViewWrapper className="react-component" as="span">
      <Tooltip title={<RichText html={text} />}>
        <span className="link link-citation">{label}</span>
      </Tooltip>
    </NodeViewWrapper>
  );
};

export const getCitationLinkExtensionRenderOptions = (): CitationLinkExtensionRenderOptions => {
  return {
    viewComponent: CitationLinkView,
    renderText: (node) => renderText(node),
  };
};
